<h1 mat-dialog-title class="edit-form-title fixed-title">Employee</h1>
    <mat-dialog-content class="edit-form-content">
      <mat-form-field class="fixed-filter">
        <input matInput (keyup)="applyFilter($event)" placeholder="Filter">
      </mat-form-field>
      <mat-checkbox [(ngModel)]="showSelected" (change)="showSelectedItems()">Show selected items only</mat-checkbox>
      <div class="scrollable-content">
        <table mat-table [dataSource]="dataSource">

          <!-- Tick Icon Column -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef style="width: 50px;">
              <!-- Checkbox for select all if multi-select is enabled -->
              <!-- <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelected()" *ngIf="selection.isMultiSelect()"></mat-checkbox> -->
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="toggleRow(row)"
                [checked]="isRowSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Employee </th>
            <td mat-cell *matCellDef="let item" [ngClass]="{ 'selected-row': selection.isSelected(item) }" (click)="selectRow(item)">
              {{ getEmployeeName(item) }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="footer">
      <button mat-raised-button color="primary" (click)="save()">OK</button>
      <button mat-button (click)="cancel()">Cancel</button>
    </mat-dialog-actions>